import { ArrowRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { CategoryDto } from '@entities/product/api/productApi';
import type { ShopDto } from '@entities/shop/api/shopApi';
import { SearchField } from '@shared/ui/SearchField';
import { ButtonLink } from '@shared/ui/Button';
import { CategoryTabs } from '@widgets/CategoryTabs/CategoryTabs';
import { CategoryRail } from '@widgets/CategoryRail/CategoryRail';
import { SectionSkeleton } from '@widgets/PageSkeleton/PageSkeleton';
import { CatalogControls, type ChangeMarketFilter } from './CatalogControls';
import { ShopHeader } from './ShopHeader';
import styles from './MarketplaceFrame.module.css';

export interface MarketFilters { query: string; category: string; sort: string; min: string; max: string; available: boolean }
export function MarketplaceFrame({ categories, filters, change, count, total, shop, children, promotions, featured, miniApp = false, categoriesLoading = false, productsLoading = false }: {
  categories: CategoryDto[]; filters: MarketFilters; change: ChangeMarketFilter;
  count: number; total: number; shop?: ShopDto; children: ReactNode; promotions?: ReactNode; featured?: ReactNode;
  miniApp?: boolean; categoriesLoading?: boolean; productsLoading?: boolean;
}) {
  return <div className={[styles.market, miniApp ? styles.miniApp : ''].filter(Boolean).join(' ')}>
    <div className={miniApp ? styles.miniAppSearch : styles.mobileSearch}><SearchField query={filters.query} onChange={value => change('query', value)} placeholder={shop ? `Search ${shop.name}` : 'Search digital products'} label="Search digital products" flush /></div>
    {shop && <ShopHeader shop={shop} />}
    {miniApp
      ? categoriesLoading ? <SectionSkeleton variant="categories" /> : <CategoryRail categories={categories} value={filters.category} onChange={id => change('category', id)} />
      : <div className={styles.mobileCategories}><CategoryTabs categories={categories} value={filters.category} onChange={id => change('category', id)} loading={categoriesLoading} /></div>}
    {promotions}
    {featured}
    <section className={styles.catalog} id="catalog" aria-label="Product results">
      <CatalogControls miniApp={miniApp} categories={categories} categoriesLoading={categoriesLoading} filters={filters} change={change} count={count} total={total} shopName={shop?.name} loading={productsLoading} />
      {children}
    </section>
    {!miniApp && !shop && <section className={styles.sellerRow} aria-label="Sell on YeneShop"><div><h2>Sell digital products</h2><p>Open a shop and list your digital products on YeneShop.</p></div><ButtonLink to="/seller">Create your shop <ArrowRight size={18} /></ButtonLink></section>}
    {!miniApp && <footer className={styles.footer}>
      <div className={styles.footerIdentity}><strong>YeneShop</strong><span>Digital products only · Prices in ETB</span></div>
      <nav aria-label="Your YeneShop"><strong>Your YeneShop</strong><Link to="/orders">Your orders</Link><Link to="/seller">My shop</Link></nav>
      <nav aria-label="Legal"><strong>Information</strong><a href="/privacy.html">Privacy policy</a><a href="/terms.html">Terms of service</a></nav>
    </footer>}
  </div>;
}
